import { render } from "./ActionItem.vue?vue&type=template&id=2fb14173&scoped=true"
import script from "./ActionItem.vue?vue&type=script&lang=js"
export * from "./ActionItem.vue?vue&type=script&lang=js"

import "./ActionItem.vue?vue&type=style&index=0&id=2fb14173&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb14173"]])

export default __exports__